'use strict';

/**
 * Modal view for an iframe
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');

var template = require('modules/base/templates/layout/iframe-modal.hbs');

var IframeModalView = ColidoLayoutView.extend({
    template: template,

    ui: {
        actionClose: '[data-action="close"]',
        headline: 'h2',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
        'click @ui.headline': 'actionClose',
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },
});

module.exports = IframeModalView;